import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";

class FlowsheetActions extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    public loadFlowsheets(encounterId: string, patientId: string): void {
        this.Execute(
            ServerOperations.Server.Myle_FlowsheetModule_FindFlowsheetSummaries,
            {
                EncounterId: encounterId,
                PatientId: patientId
            }
        );
    }
}

export {
    FlowsheetActions
};
